import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  MapPinIcon,
  CreditCardIcon,
  LockClosedIcon,
} from '@heroicons/react/24/outline';
import '../Checkout.css';

interface CheckoutHeaderProps {
  currentStep: number;
}

const CheckoutHeader: React.FC<CheckoutHeaderProps> = ({ currentStep }) => {
  const { t } = useTranslation();

  const steps = [
    { number: 1, title: t('checkout.shipping'), icon: MapPinIcon },
    { number: 2, title: t('checkout.billing'), icon: CreditCardIcon },
    { number: 3, title: t('checkout.payment'), icon: LockClosedIcon },
  ];

  return (
    <div className="checkout-header">
      <h1>{t('checkout.title')}</h1>
      <div className="checkout-steps">
        {steps.map((step) => {
          const IconComponent = step.icon;
          return (
            <div
              key={step.number}
              className={`step ${currentStep >= step.number ? 'active' : ''} ${
                currentStep === step.number ? 'current' : ''
              }`}
            >
              <div className="step-icon">
                <IconComponent className="icon" />
              </div>
              <span className="step-title">{step.title}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CheckoutHeader;
